import { createFileRoute } from '@tanstack/react-router';

import { ShippingPage } from '@/features/marketing/pages/shipping';
import { destinationSearch } from '@/utils/destination-search';

export const Route = createFileRoute('/shipping')({
	// Порт призначення, до якого рахує вітрина (`?to=`).
	validateSearch: destinationSearch,
	component: ShippingPage,
});
